export default defineNuxtRouteMiddleware(async (to) => {
	// Skip if /metrics or /health
	if (to.path === '/metrics' || to.path === '/health') {
		return
	}

	// Exclude for public routes
	if (unauthenticatedRoutes.includes(to.path)) {
		return
	}

	// Load the organisation
	try {
		await useOrganisation().getOrganisation()
	} catch (error) {
		console.error('Error getting the organisation: ', error)
		throw error
	}
})
